module.exports = __webpack_public_path__ + "img/follow-up-icon.fbd4baee.svg";